import React, { useState, useEffect } from "react";
import "./style.css";
import Table from "react-bootstrap/Table";
import API from "../../utils/API";

function CreateCarrier() {
  const [formData, setFormData] = useState({
    carrierName: "",
    carrierLogo: "",
    carrierServiceNumber: "",
    carrierClaimsNumber: "",
    customerPortalLink: "",
    carrierData: "",
    carrierSelected: "",
    carrierSelectedID: "",
    selectedCarrierName: "",
    selectedCarrierLogo: "",
    selectedCarrierServiceNumber: "",
    selectedCarrierClaimsNumber: "",
    selectedCarrierCustomerPortalLink: ""
  });

  useEffect(() => {
    console.log("Create Carrier Modal Component Launched");

    API.getCarriers().then((res) => {
      console.log("Carreirs Retrieved from API");
      console.log(res);
      setFormData((prev) => ({
        ...prev,
        carrierData: res.data
      }));
    });
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCarrierSubmit = (event) => {
    event.preventDefault();
    console.log("Submitting Carrier ....");

    const carrierSubmitData = {
      name: formData.carrierName,
      logo: formData.carrierLogo,
      servicePhone: formData.carrierServiceNumber,
      claimsPhone: formData.carrierClaimsNumber,
      serviceURL: formData.customerPortalLink
    };

    console.log(carrierSubmitData);

    API.saveCarrier(carrierSubmitData)
      .then((_res) => {
        console.log("Saved Carrier");
        alert("Carrier Saved!");
      })
      .catch((err) => console.log(err));
  };

  const handleCarrierEditSubmit = (event) => {
    event.preventDefault();
    console.log("Submitting Carrier Edits....");

    const carrierID = formData.carrierSelectedID;

    const carrierEditData = {
      name: formData.selectedCarrierName,
      logo: formData.selectedCarrierLogo,
      servicePhone: formData.selectedCarrierServiceNumber,
      claimsPhone: formData.selectedCarrierClaimsNumber,
      serviceURL: formData.selectedCarrierCustomerPortalLink
    };

    console.log(carrierEditData);

    API.updateCarrier(carrierID, carrierEditData)
      .then((_res) => {
        console.log("Saved Edits to Carrier");
        alert("Carrier Edits Saved!");

        API.getCarriers().then((res) => {
          console.log("Carreirs Retrieved from API");
          console.log(res);
          setFormData((prev) => ({
            ...prev,
            carrierData: res.data
          }));
        });
      })
      .catch((err) => console.log(err));
  };

  const populateCarrierDataInForm = (event) => {
    event.preventDefault();
    console.log("Populating Carrier Edit Form");

    for (let i = 0; i < formData.carrierData.length; i++) {
      if (formData.carrierSelected === formData.carrierData[i]._id) {
        console.log("Found Client Data to Edit:");
        console.log(formData.carrierData[i]);
        setFormData((prev) => ({
          ...prev,
          carrierSelectedID: formData.carrierData[i]._id,
          selectedCarrierName: formData.carrierData[i].name,
          selectedCarrierServiceNumber: formData.carrierData[i].servicePhone,
          selectedCarrierClaimsNumber: formData.carrierData[i].claimsPhone,
          selectedCarrierCustomerPortalLink: formData.carrierData[i].serviceURL,
          selectedCarrierLogo: formData.carrierData[i].logo
        }));
      }
    }
  };

  return (
    <div>
      <div
        className="card"
        style={{ borderRadius: "10px", color: "black", overflow: "auto", padding: "0" }}
      >
        <div className="card-header" style={{ textAlign: "center" }}>
          <h3 style={{ textAlign: "center" }}>New Carrier</h3>
          <p>Create Carrier below</p>
        </div>
        <div className="card-body" style={{ padding: "0" }}>
          <form>
            <Table bordered hover>
              <tbody>
                <tr>
                  <td>
                    <strong>Question</strong>
                  </td>
                  <td>
                    <strong>Input</strong>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Carrier Name
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.carrierName}
                      onChange={handleInputChange}
                      name="carrierName"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Carrier Logo
                  </td>
                  <td>
                    {" "}
                    <input
                      type="text"
                      value={formData.carrierLogo}
                      onChange={handleInputChange}
                      name="carrierLogo"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Service Telephone #
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.carrierServiceNumber}
                      onChange={handleInputChange}
                      name="carrierServiceNumber"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Claims Telephone #
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.carrierClaimsNumber}
                      onChange={handleInputChange}
                      name="carrierClaimsNumber"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Customer Portal Link
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.customerPortalLink}
                      onChange={handleInputChange}
                      name="customerPortalLink"
                    />{" "}
                  </td>
                </tr>
              </tbody>
            </Table>
            <div style={{ textAlign: "center" }}>
              <button
                style={{
                  color: "white",
                  fontSize: "20px",
                  boxShadow: "0px 0px 1px 1px black",
                  backgroundImage: "linear-gradient(147deg, black 90%, white 0%)",
                  padding: "5px 20px 5px 20px",
                  borderRadius: "5px"
                }}
                onClick={(e) => handleCarrierSubmit(e)}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
      <br />

      <div
        className="card"
        style={{ borderRadius: "10px", color: "black", overflow: "auto", padding: "0" }}
      >
        <div className="card-header" style={{ textAlign: "center" }}>
          <h3 style={{ textAlign: "center" }}>Edit Carrier</h3>
          <p>Select a Carrier to Edit Below</p>
        </div>
        <div className="card-body" style={{ padding: "0" }}>
          <form>
            <Table bordered hover>
              <tbody>
                <tr>
                  <td>
                    <strong>Select Carrier</strong>
                  </td>
                  <td>
                    <form>
                      {formData.carrierData ? (
                        <select
                          id="carrierDropMenu"
                          value={formData.carrierSelected}
                          onChange={handleInputChange}
                          name="carrierSelected"
                        >
                          {formData.carrierData.map((carrier) => (
                            <option key={carrier._id} value={carrier._id}>
                              {carrier.name}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <div>No Carriers yet</div>
                      )}

                      <button onClick={populateCarrierDataInForm}>Edit</button>
                    </form>
                  </td>
                </tr>

                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Carrier Name
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.selectedCarrierName}
                      onChange={handleInputChange}
                      name="selectedCarrierName"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Carrier Logo
                  </td>
                  <td>
                    {" "}
                    <input
                      type="text"
                      value={formData.selectedCarrierLogo}
                      onChange={handleInputChange}
                      name="selectedCarrierLogo"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Service Telephone #
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.selectedCarrierServiceNumber}
                      onChange={handleInputChange}
                      name="selectedCarrierServiceNumber"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Claims Telephone #
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.selectedCarrierClaimsNumber}
                      onChange={handleInputChange}
                      name="selectedCarrierClaimsNumber"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Customer Portal Link
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.selectedCarrierCustomerPortalLink}
                      onChange={handleInputChange}
                      name="selectedCarrierCustomerPortalLink"
                    />{" "}
                  </td>
                </tr>
              </tbody>
            </Table>
            <div style={{ textAlign: "center" }}>
              <button
                style={{
                  color: "white",
                  fontSize: "20px",
                  boxShadow: "0px 0px 1px 1px black",
                  backgroundImage: "linear-gradient(147deg, black 90%, white 0%)",
                  padding: "5px 20px 5px 20px",
                  borderRadius: "5px"
                }}
                onClick={(e) => handleCarrierEditSubmit(e)}
              >
                Save Edit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateCarrier;
